import {Checkbox, CheckboxProps, Modal, notification} from "antd";
import {useQuoteContext} from "../../contexts/QuoteContext";
import useQuote from "../../swr/useQuote";
import {useIntl} from "react-intl";
import React, {useContext} from "react";
import {ConfiguratorContext} from "../../context";
import {ExclamationCircleFilled} from "@ant-design/icons";
import Configurator from "../../pages/configurator";

const InventoryCheckbox = (props:CheckboxProps) => {

    const { quote } = useQuoteContext();
    const quoteAsync = useQuote({ quoteId: quote?.quoteId, revision: quote?.revision });

    const intl = useIntl();
    const configurator = useContext(ConfiguratorContext);

    const convertToStock = async (quoteId:number, enabled:boolean) => {

        try {

            const resp = await configurator.api.convertQuoteToStock(quoteId, enabled);
            await quoteAsync.mutate(resp.data);

        } catch (e:any) {
            const errorMsg = intl.formatMessage({ id: e.message });
            notification.error( { message: "Failed to convert to stock. " + errorMsg });
        }
    }

    const handleConvertStock = () => {
        if ( !quote ) return;

        if ( !quote.stock ) {
            Modal.confirm({
                title: 'Are you sure?',
                icon: <ExclamationCircleFilled />,
                content: 'This will move the order to inventory where it can be re-sold.',
                onOk: () => convertToStock(quote.id, true),
            });
        }
        else {
            Modal.confirm({
                title: 'Are you sure?',
                icon: <ExclamationCircleFilled />,
                content: 'This will move the order out of inventory.',
                onOk: () => convertToStock(quote.id, false),
            });
        }

    }

    return <div style={{marginLeft: "1rem"}}>
        <label >
            <Checkbox
                {...props}
                checked={quote?.stock}
                onChange={() => handleConvertStock()}
                style={{padding:0}}
            />
            <span style={{marginLeft: "0.5rem"}}>Inventory</span>
        </label>
    </div>
}

export default InventoryCheckbox;
